<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>
        <v-row>
          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn small color="#E0E0E0" @click="dialogEdit = false">
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row>
                      <v-col cols="12" class="text-left">
                        <h1 class="font-weight-bold">อัพเดทการจัดส่ง</h1>
                        <!-- {{formView}} <br> {{formUpdate}} -->
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="mx-3">
                        <v-expansion-panels v-model="panel" multiple>
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              >ข้อมูลของรางวัล</v-expansion-panel-header
                            >
                            <!-- {{formView}} <br> {{formUpdate}} -->
                            <v-expansion-panel-content>
                              <v-card
                                class="mx-auto mt-3"
                                max-width="400"
                                outlined
                              >
                                <v-list-item three-line>
                                  <v-list-item-avatar
                                    tile
                                    size="80"
                                    color="grey"
                                  >
                                    <v-img :src="formView.pictureUrl"></v-img>
                                  </v-list-item-avatar>

                                  <v-list-item-content>
                                    <h3 class="text-left mt-6 text-overline">
                                      {{ formView.name }}
                                    </h3>
                                    <h4 class="text-left">
                                      <b>รายละเอียด : </b>
                                      {{ formView.description }}
                                    </h4>
                                    <h4 class="text-left">
                                      <b>ประเภทจัดส่ง : </b>
                                      {{ formView.supply }}
                                    </h4>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>

                          <v-expansion-panel>
                            <v-expansion-panel-header
                              >ข้อมูลลูกค้า</v-expansion-panel-header
                            >
                            <v-expansion-panel-content>
                              <v-card
                                class="mx-auto mt-3"
                                max-width="400"
                                outlined
                              >
                                <v-list-item three-line>
                                  <v-list-item-content>
                                    <h3 class="text-left mt-6 text-overline">
                                      {{ formView.lineName }}
                                    </h3>
                                    <h4 class="text-left">
                                      <b>ชื่อ-นามสกุล :</b>
                                      {{ formView.nameSurname }}
                                    </h4>
                                    <h4 class="text-left">
                                      <b>ระดับ :</b> {{ formView.levelName }}
                                    </h4>
                                    <h4 class="text-left">
                                      <b>คะแนนปัจจุบัน :</b>
                                      {{ formView.currentPoint }} คะแนน
                                    </h4>
                                    <h4 class="text-left">
                                      <b>ที่อยู่ :</b>
                                      {{ formView.houseNumber }}
                                      {{ formView.subDistrict }}
                                      {{ formView.district }}
                                      {{ formView.provinces }}
                                      {{ formView.postalCode }}
                                    </h4>
                                    <h4 class="text-left">
                                      <b>เบอร์โทรศัพท์ :</b>
                                      {{ formView.tel }}
                                    </h4>
                                  </v-list-item-content>

                                  <v-list-item-avatar
                                    tile
                                    size="80"
                                    color="grey"
                                    ><v-img :src="formView.linePicture"></v-img
                                  ></v-list-item-avatar>
                                </v-list-item>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>

                          <v-expansion-panel>
                            <v-expansion-panel-header
                              >อัพเดตสถานะ</v-expansion-panel-header
                            >
                            <v-expansion-panel-content>
                              <v-col cols="12">
                                <v-row style="height: 65px">
                                  <v-col cols="6">
                                    <v-text-field
                                      v-model="formUpdate.parcelNumber"
                                      label="เลขพัสดุ"
                                      placeholder="เลขพัสดุ"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="6">
                                    <v-select
                                      v-model="formUpdate.Transport"
                                      :items="itemstransport"
                                      label="ขนส่ง"
                                      outlined
                                      dense
                                    ></v-select>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12">
                                <v-row style="height: 65px">
                                  <v-checkbox
                                    v-model="formUpdate.sendStatus"
                                    label="จัดส่งแล้ว"
                                    class="mx-auto"
                                  ></v-checkbox>
                                </v-row>
                              </v-col>

                              <v-spacer></v-spacer>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions id="v-step-3">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      :disabled="!validUpdate"
                      color="#173053"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="ชื่อสินค้า"
                        outlined
                        dense
                        v-model="formUpdate.name"
                        readonly
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="formUpdate.lineName"
                        label="ผู้แลกสินค้า"
                        dense
                        outlined
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  color="red darken-1"
                  @click="deleteCF()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- dialog Printer -->
          <v-dialog v-model="dialogPrinter" persistent max-width="70%">
            <v-card>
              <iframe id="pdfV" style="width:100%; height: 1200px"> </iframe>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogPrinter = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- filter section -->
          <v-col cols="12">
            <v-card elevation="3" class="mb-5">
              <v-card-title class="primary white--text">
                <v-icon color="white" class="mr-2">mdi-filter-variant</v-icon>
                ฟิลเตอร์ข้อมูล
              </v-card-title>
              <v-card-text class="pt-6">
                <v-row align="center">
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="filterSendStatus"
                      :items="sendStatusOptions"
                      label="สถานะจัดส่ง"
                      prepend-inner-icon="mdi-truck-delivery"
                      outlined
                      dense
                      clearable
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu
                      v-model="menuDateRange"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="dateRangeText"
                          label="ช่วงวันที่แลกสินค้า"
                          prepend-inner-icon="mdi-calendar-range"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details
                          clearable
                          @click:clear="clearDateRange"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filterDateRange"
                        range
                        no-title
                        scrollable
                        color="primary"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="grey"
                          @click="menuDateRange = false"
                        >
                          ยกเลิก
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="menuDateRange = false"
                        >
                          ตกลง
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" class="d-flex justify-center">
                    <v-btn
                      color="primary"
                      large
                      block
                      @click="applyFilters()"
                      elevation="2"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      ค้นหา
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end filter section -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady && dataItem.length > 0">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:no-data>
                    <div class="text-center pa-12">
                      <v-icon size="100" color="grey lighten-1">mdi-package-variant-closed</v-icon>
                      <h2 class="grey--text text--darken-2 mt-6 mb-2">ไม่พบข้อมูลการจัดส่ง</h2>
                      <p class="grey--text text--darken-1 text-body-1">
                        ลองปรับเปลี่ยนตัวกรองหรือช่วงวันที่เพื่อค้นหาข้อมูล
                      </p>
                      <v-btn color="primary" outlined class="mt-4" @click="clearFilters()">
                        <v-icon left>mdi-refresh</v-icon>
                        รีเซ็ตตัวกรอง
                      </v-btn>
                    </div>
                  </template>
                  <template v-slot:no-results>
                    <div class="text-center pa-10">
                      <v-icon size="80" color="orange darken-1">mdi-magnify-remove-outline</v-icon>
                      <h3 class="orange--text text--darken-1 mt-4 mb-2">ไม่พบผลการค้นหา</h3>
                      <p class="grey--text text--darken-1">
                        ไม่พบข้อมูลที่ตรงกับ "<strong>{{ searchAll2 }}</strong>"
                      </p>
                      <p class="grey--text mt-1">ลองใช้คำค้นหาอื่นหรือตรวจสอบการสะกด</p>
                    </div>
                  </template>
                  <template v-slot:[`item.useDate`]="{ item }">
                    {{ format_dateNotime(item.useDate) }}
                  </template>
                  <template v-slot:[`item.packagePrice`]="{ item }">
                    {{ formatNumber(item.packagePrice) }}
                  </template>
                  <template v-slot:[`item.packageExpri`]="{ item }">
                    {{ item.packageExpri }}
                  </template>
                  <template v-slot:[`item.pictureUrl`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.pictureUrl" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.sendStatus`]="{ item }">
                    <v-chip :color="getColor(item.sendStatus)" dark>
                      {{ item.sendStatus }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="success"
                          fab
                          x-small
                          @click.stop="updateStatus(item)"
                        >
                          <v-icon dark> mdi-update </v-icon>
                        </v-btn>
                      </template>
                      <span>อัพเดทสถานะจัดส่ง</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="deleteData(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          v-if="item.sendStatus === 'รอจัดส่ง'"
                          color="primary"
                          dark
                          fab
                          x-small
                          @click.stop=";(dialogPrinter = true), printer(item)"
                        >
                          <v-icon> mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>ปริ้นที่จัดส่ง</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center pa-12">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                width="6"
              ></v-progress-circular>
              <p class="mt-4 text-h6 grey--text">กำลังโหลดข้อมูล...</p>
            </div>
            
            <v-card elevation="3" v-if="dataReady && dataItem.length === 0">
              <v-card-text>
                <div class="text-center pa-12">
                  <v-icon size="100" color="grey lighten-1">mdi-package-variant-closed</v-icon>
                  <h2 class="grey--text text--darken-2 mt-6 mb-2">ไม่พบข้อมูลการจัดส่ง</h2>
                  <p class="grey--text text--darken-1 text-body-1 mb-4">
                    ลองปรับเปลี่ยนตัวกรองหรือช่วงวันที่เพื่อค้นหาข้อมูล
                  </p>
                  <v-btn color="primary"  @click="clearFilters()">
                    <v-icon left>mdi-refresh</v-icon>
                    รีโหลด
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import { VueEditor } from 'vue2-editor'
import VuetifyMoney from '../VuetifyMoney.vue'
import pdfMake from 'pdfmake'
import pdfFonts from '../../assets/my-fonts/custom-fonts.js' // 1. import custom fonts

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VueEditor,
    VuetifyMoney,
    pdfMake,
    pdfFonts
  },
  data () {
    return {
      PK: '',
      path: '/rewardCode/', // Path Model
      returnLink: '/System/Transport',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ติดตามการจัดส่ง',
          disabled: false,
          href: '/System/Transport'
        }
      ],
      // End Menu Config
      dataReady: true,
      date: new Date().toISOString().substr(0, 10),
      // Dialog Config ADD EDIT DELETE IMPORT
      menu1: false,
      menu2: false,
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogPrinter: false,
      session: this.$session.getAll(),
      // Filter Config
      filterSendStatus: 'รอจัดส่ง',
      filterDateRange: (() => {
        const today = new Date()
        const oneMonthAgo = new Date()
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)
        return [
          oneMonthAgo.toISOString().slice(0, 10),
          today.toISOString().slice(0, 10)
        ]
      })(),
      menuDateRange: false,
      sendStatusOptions: [
        { text: 'ทั้งหมด', value: 'all' },
        { text: 'รอจัดส่ง', value: 'รอจัดส่ง' },
        { text: 'จัดส่งสำเร็จ', value: 'จัดส่งสำเร็จ' }
      ],
      // Search All
      searchAll: '',
      searchAll2: '',
      filesAdd: null,
      filesUpdate: null,
      nowDate: new Date().toISOString().slice(0, 10),
      itemstransport: [
        'Kerry Express',
        'Nim Express',
        'DHL Express',
        'SCG Express',
        'Alpha Fast',
        'Flash Express',
        'J&T Express',
        'Ninja Van',
        'ไปรษณีย์ไทย'
      ],
      formView: {
        pictureUrl: '',
        name: '',
        description: '',
        supply: '',
        sendStatus: '',
        linePicture: '',
        lineName: '',
        levelName: '',
        houseNumber: '',
        district: '',
        subDistrict: '',
        provinces: '',
        postalCode: '',
        currentPoint: '',
        rewardCodeId: '',
        tel: '',
        parcelNumber: '',
        nameSurname: '',
        Transport: ''
      },
      formUpdate: {
        rewardCodeId: '',
        sendStatus: '',
        LAST_USER: '',
        LAST_DATE: '',
        parcelNumber: '',
        Transport: ''
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รูป', value: 'pictureUrl' },
        { text: 'ชื่อของรางวัล', value: 'name' },
        { text: 'ประเภทจัดส่ง', value: 'supply' },
        { text: 'ขนส่ง', value: 'Transport' },
        { text: 'สถานะจัดส่ง', value: 'sendStatus' },
        { text: 'วันที่แลกสินค้า', value: 'useDate' },
        { text: 'ผู้แลกสินค้า', value: 'lineName' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      validAdd: true,
      validUpdate: true,
      // End Data Table Config
      panel: [0, 1, 2]
    }
  },
  computed: {
    dateRangeText () {
      if (!this.filterDateRange || this.filterDateRange.length === 0) {
        return ''
      }
      if (this.filterDateRange.length === 1) {
        return this.filterDateRange[0]
      }
      // เรียงวันที่ให้ถูกต้อง
      const dates = [...this.filterDateRange].sort()
      return `${dates[0]} - ${dates[1]}`
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getData()
    await this.getColor()
  },
  methods: {
    printer (item) {
      axios
        .get(
          this.DNS_IP +
            '/rewardCode/getData?shopId=' +
            this.session.data.shopId +
            '&supply=จัดส่ง&rewardCodeId=' +
            item.rewardCodeId
        )
        .then(response => {
          let rs = response.data
          if (rs.status === false) {
            this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          } else {
            let data = rs[0]
            // console.log('res', data)
            const docDefinition = {
              pageSize: 'A5',
              pageOrientation: 'landscape',
              content: [
                {
                  alignment: 'left',
                  columns: [
                    {
                      text:
                        'ผู้ส่ง\n' +
                        data.shopName +
                        '\nเลขที่' +
                        ' ' +
                        data.detailAddress +
                        ' ' +
                        data.subDistrictShop +
                        '\n' +
                        data.districtShop +
                        ' ' +
                        data.provincesShop +
                        ' ' +
                        data.postalCodeShop +
                        '\n' +
                        data.contactTel
                    },
                    {}
                  ]
                },
                {
                  alignment: 'left',
                  columns: [
                    {},
                    {
                      text:
                        'ผู้รับ\nคุณ' +
                        ' ' +
                        data.nameSurname +
                        '\nเลขที่' +
                        ' ' +
                        data.houseNumber +
                        ' ' +
                        data.subDistrict +
                        '\n' +
                        data.district +
                        ' ' +
                        data.provinces +
                        ' ' +
                        data.postalCode +
                        '\n' +
                        data.tel
                    }
                  ]
                }
              ],
              styles: {
                header: {
                  fontSize: 18,
                  bold: true
                },
                bigger: {
                  fontSize: 15,
                  italics: true
                },
                nomal: {
                  fontSize: 15
                },
                tableHeader: {
                  bold: true,
                  fontSize: 13,
                  color: 'black'
                }
              },
              defaultStyle: {
                // 4. default style 'KANIT' font to test
                font: 'Kanit'
              }
            }
            pdfMake.vfs = pdfFonts.pdfMake.vfs // 2. set vfs pdf font
            pdfMake.fonts = {
              // download default Roboto font from cdnjs.com
              Roboto: {
                normal:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                bold:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                italics:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                bolditalics:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
              },
              // Kanit Font
              Kanit: {
                // 3. set Kanit font
                normal: 'Kanit-Regular.ttf',
                bold: 'Kanit-Medium.ttf',
                italics: 'Kanit-Italic.ttf',
                bolditalics: 'Kanit-MediumItalic.ttf'
              }
            }
            // pdfMake.createPdf(docDefinition).open({}, window)
            pdfMake.createPdf(docDefinition).getDataUrl(function (outDoc) {
              document.getElementById('pdfV').src = outDoc
            })
          }
        })
    },
    getData () {
      this.dataReady = false
      
      let url = this.DNS_IP + '/rewardCode/getData?shopId=' + this.session.data.shopId + '&supply=จัดส่ง'
      
      if (this.filterSendStatus && this.filterSendStatus !== 'all') {   
        const oppositeStatus = this.filterSendStatus === 'รอจัดส่ง' ? 'จัดส่งสำเร็จ' : 'รอจัดส่ง'
        url += '&sendStatus=' + encodeURIComponent(oppositeStatus)
      } else if (!this.filterSendStatus || this.filterSendStatus === 'all') {
        url += '&sendStatus=null'
      }
      
      if (this.filterDateRange && this.filterDateRange.length > 0) {
        const dates = [...this.filterDateRange].sort()
        url += '&startDate=' + dates[0]
        if (dates.length === 2) {
          url += '&endDate=' + dates[1]
        } else {
          url += '&endDate=' + dates[0]
        }
      }
      
      axios
        .get(url)
        .then(response => {
          let rs = response.data
          // console.log('API Response:', rs) // Debug
          // console.log('Is Array:', Array.isArray(rs)) // Debug
          
         
          if (Array.isArray(rs)) {
            this.dataItem = rs
          } else if (rs && rs.status === false) {
            this.dataItem = []
          } else if (rs && typeof rs === 'object' && rs.data) {
            this.dataItem = Array.isArray(rs.data) ? rs.data : []
          } else {
            this.dataItem = []
          }
          
          this.dataReady = true
          // console.log('dataItem.length:', this.dataItem.length) // Debug
          // console.log('dataReady:', this.dataReady) // Debug
          // console.log('Should show empty state:', this.dataReady && this.dataItem.length === 0) // Debug
        })
        .catch(error => {
          // console.log('Error fetching data:', error)
          this.dataItem = []
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ไม่สามารถดึงข้อมูลได้', 'error')
        })
    },
    applyFilters () {
      this.getData()
    },
    clearFilters () {
      this.filterSendStatus = 'รอจัดส่ง'
      const today = new Date()
      const oneMonthAgo = new Date()
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)
      this.filterDateRange = [
        oneMonthAgo.toISOString().slice(0, 10),
        today.toISOString().slice(0, 10)
      ]
      this.getData()
    },
    clearDateRange () {
      this.filterDateRange = []
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async updateStatus (item) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/rewardCode/getData?shopId=' +
            this.session.data.shopId +
            '&supply=จัดส่ง&rewardCodeId=' +
            item.rewardCodeId
        )
        .then(async response => {
          this.dialogEdit = true

          this.formView.pictureUrl = response.data[0].pictureUrl
          this.formView.name = response.data[0].name
          this.formView.description = response.data[0].description
          this.formView.supply = response.data[0].supply
          this.formView.linePicture = response.data[0].linePicture
          this.formView.lineName = response.data[0].lineName
          this.formView.levelName = response.data[0].levelName
          this.formView.houseNumber = response.data[0].houseNumber
          this.formView.district = response.data[0].district
          this.formView.subDistrict = response.data[0].subDistrict
          this.formView.provinces = response.data[0].provinces
          this.formView.postalCode = response.data[0].postalCode
          this.formView.currentPoint = response.data[0].currentPoint
          this.formView.tel = response.data[0].tel
          this.formView.rewardCodeId = response.data[0].rewardCodeId
          this.formView.sendStatus = response.data[0].sendStatus
          this.formView.parcelNumber = response.data[0].parcelNumber
          this.formView.nameSurname = response.data[0].nameSurname
          this.formView.Transport = response.data[0].Transport
          // console.log('rsssss', this.formView.Transport)
          if (this.formView.sendStatus === 'รอจัดส่ง') {
            this.formUpdate.sendStatus = false
          } else {
            this.formUpdate.sendStatus = true
          }
          if (this.formView.parcelNumber) {
            // console.log(this.formView.parcelNumber)
            this.formUpdate.parcelNumber = this.formView.parcelNumber
          }
          if (this.formView.Transport) {
            // console.log(this.formView.Transport)
            this.formUpdate.Transport = this.formView.Transport
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          // console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    getColor (sendStatus) {
      if (sendStatus === 'รอจัดส่ง') return 'red'
      else return 'green'
    },
    async editData () {
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.formUpdate.LAST_USER = this.session.data.userName
          this.formUpdate.LAST_DATE = this.nowDate
          var ID = this.formView.rewardCodeId
          if (this.formUpdate.sendStatus === true) {
            this.formUpdate.sendStatus = 'จัดส่งสำเร็จ'
          } else if (this.formUpdate.sendStatus === false) {
            this.formUpdate.sendStatus = 'รอจัดส่ง'
          }
          // console.log('sendStatus', this.formUpdate.sendStatus)
          delete this.formUpdate['rewardCodeId']
          delete this.formUpdate['LAST_DATE']
          await axios
            .post(this.DNS_IP + this.path + 'editData/' + ID, this.formUpdate)
            .then(async response => {
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dialogEdit = false
              this.getData()
            })
            .catch(error => {
              this.dataReady = true
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              // console.log('error function editDataGlobal1 : ', error)
            })
        })
        .catch(error => {
          this.dataReady = true
          // console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData (item) {
      this.dataReady = false
      axios
        .get(
          this.DNS_IP +
            '/rewardCode/getData?shopId=' +
            this.session.data.shopId +
            '&rewardCodeId=' +
            item.rewardCodeId +
            '&supply=จัดส่ง&sendStatus=null'
        )
        .then(response => {
          this.dialogDelete = true
          this.formUpdate.LAST_USER = this.session.data.userName
          this.formUpdate.LAST_DATE = this.session.data.nowDate
          this.formUpdate.name = response.data[0].name
          this.formUpdate.lineName = response.data[0].lineName
          this.formUpdate.rewardCodeId = response.data[0].rewardCodeId
          this.formUpdate.sendStatus = response.data[0].sendStatus
          // console.log(response)
        })
    },
    deleteCF () {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          //   var ID = this.formUpdate.rewardCodeId
          // console.log(
          //   'id',
          //   this.DNS_IP + this.path + 'delete/' + this.formUpdate.rewardCodeId,
          //   this.formUpdate
          // )
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                this.path +
                'delete/' +
                this.formUpdate.rewardCodeId,
              this.formUpdate
            )
            .then(async response => {
              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              this.dialogDelete = false

              // Load Data
              this.getData()
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              // console.log('error function deleteDataGlobal55 : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          // console.log('error function deleteDataGlobal : ', error)
        })
    }
  }
}
</script>
<style scpped></style>



// WEBPACK FOOTER //
// src/components/System/Transport.vue